import React, { useState } from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { OrderReason, ReasonsForMaxFileSent } from 'app/constants/OrderCreationForm';
import { useTranslation } from 'react-i18next';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import { useSelector } from 'react-redux';
import { selectOrderRegions } from '@AMIEWEB/Order/Store/Order.selectors';

interface props {
  title: string;
  value: string;
  name: string;
  handleChange(property: string, value: any): void;
  disableEdit: boolean;
}

const useStyles = makeStyles()(theme => ({
  root: {
    borderTopRightRadius: '0px !important',
    borderTopLeftRadius: '0px !important',
    '&&&:before': {
      borderBottom: '2px solid #B9BBBC',
    },
    '&&:after': {
      borderBottom: '2px solid #B9BBBC',
    },
    '& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
      display: 'none',
    },
    '& .MuiFilledInput-input': {
      padding: '4px 25px 2px 4px',
      width: 87,
      fontSize: 14,
      height: 18,
    },
    '& .MuiSelect-icon': {
      top: 'calc(50% - 10px)',
      cursor: 'pointer',
    },
    '& .MuiSvgIcon-root': {
      fontSize: '1.2rem',
    },
  },
  dropdownStyle: {
    border: '1px solid #D1D1D1',
    boxShadow: 'none',
    borderRadius: 3,
    marginTop: '0.5em',
    overflowY: 'auto',
    minHeight: '5%',
    maxHeight: '184px',
    width: 150,
  },
  menuListItem: {
    fontSize: 14,
    textOverflow: 'ellipsis',
    maxWidth: '22ch',
    minWidth: '22ch',
    display: 'inline-block',
    '&.MuiMenuItem-root': {
      whiteSpace: 'unset',
    },
  },
}));

export const PickList = (pickList: props) => {
  const { t } = useTranslation();
  const { title, handleChange, name, disableEdit } = pickList;
  const [pickListValue, setPickListValue] = useState<string>(pickList.value);
  const Region = useSelector(selectOrderRegions)
  const { classes } = useStyles();
  const handleValueChange = e => {
    setPickListValue(e.target.value);
    handleChange(name, e.target.value);
  };
  return (
    <FormControl variant="filled">
      <Select
        disableUnderline
        disabled={disableEdit}
        value={pickListValue}
        onChange={handleValueChange}
        IconComponent={ExpandMoreOutlinedIcon}
        className={classes.root}
        data-testid="test-at-a-glance-picklist"
        MenuProps={{
          className: classes.root,
          classes: { paper: classes.dropdownStyle, list: classes.menuListItem },
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
          getContentAnchorEl: null,
        }}
      >
        {title == 'Order Reason' ? (
          OrderReason.map(item => (
            <MenuItem classes={{ root: classes.menuListItem }} key={item.id} value={item.reason}>
              {item.reason}
            </MenuItem>
          ))
        ) : title == 'Region' ? (
          Region.map(region => (
            <MenuItem classes={{ root: classes.menuListItem }} key={region.ID} value={region.Description}>
              {region.Description}
            </MenuItem>
          ))
        ) : title == 'Max Files Sent Reason' ? (
          ReasonsForMaxFileSent.map(reason => (
            <MenuItem classes={{ root: classes.menuListItem }} key={reason} value={reason}>
              {reason}
            </MenuItem>
          ))
        ) : (
          <MenuItem value={''}>{t('')}</MenuItem>
        )}
      </Select>
    </FormControl>
  );
};
